module.exports = __webpack_public_path__ + "static/media/MeasureMarkers.631085be.gif";